/** Injected by `define` in vite.config.ts at build time. */
export interface BuildInfo {
  /** Short commit hash, `-dirty` suffixed for uncommitted trees. */
  readonly commit: string;
  /** ISO timestamp of the build. */
  readonly builtAt: string;
}

declare const __BUILD_INFO__: BuildInfo;

export const buildInfo: BuildInfo =
  typeof __BUILD_INFO__ === 'undefined' ? { commit: 'dev', builtAt: '' } : __BUILD_INFO__;
